export const CheckmarkIcon = ({ color = '#fff', ...restProps }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      {...restProps}
    >
      <path
        d="M7.5 9.16668L10 11.6667L18.3333 3.33334"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 10V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H13.3333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
